import Footer from "../Components/Footer";
import Detail from "../Components/Detail";
import Hero from "../Components/Hero";
import Navbar from "../Components/Navbar";
import HomeImg from "../Assets/home3.jpg";
const About=()=>{
    return(
        <div>
            <Navbar />

            <Hero 
            cName="hero"
            heroImg={HomeImg}
            text1="Hello, I'm"
            title="Rishav Kumar"
            text2="A passionate Developer"/>

            <Detail/>
           
            <Footer/>
        </div>
    )
}
export default About;